/* eslint-disable react/no-multi-comp */

import React from 'react';
import { useTranslation } from 'react-i18next';

import './insights.scss';

import connect from '@app/utils/connect';

import overrideFilters from '@app/actions/media/overrideFilters';
import sendNotification from '@app/actions/notifications/send';
import combineActions from '@app/utils/combineActions';

import { FILTER_ORIGIN } from '@app/constants/filters';

import ErrorBoundary from '@app/ErrorBoundary';
import CrashedComponent from '@app/components/errors/CrashedComponent';

import ReFilters from '@app/components/filters';
import InsightsProvider from './InsightsContext';
import MetricsTabs from './MetricsTabs';
import InsightsChart from './InsightsChart';
import InsightsTable from './InsightsTable';

import { Typography, Flex } from '@app/ui';
import InsightsAlerts from './InsightsAlerts';
import '../components/table/table.scss';

const Insights = () => {
    const { t } = useTranslation('measurement');

    return (
        <InsightsProvider>
            <Flex
                vertical
                style={{
                    padding: 24,
                }}
            >
                <Flex>
                    <Typography.Title
                        level={4}
                        style={{
                            margin: 0,
                            color: '#1f1f1f',
                            fontWeight: 400,
                            marginBottom: 24,
                            paddingLeft: 12,
                            fontSize: 32,
                        }}
                    >
                        {t('dataExplorer.title')}
                    </Typography.Title>
                </Flex>

                <ErrorBoundary FallbackComponent={CrashedComponent}>
                    <ReFilters origin={FILTER_ORIGIN.INSIGHTS} />
                </ErrorBoundary>

                <InsightsAlerts />

                <MetricsTabs />

                <InsightsChart />
                <InsightsTable />
            </Flex>
        </InsightsProvider>
    );
};

export default connect(
    ['insights', 'filters', 'user', 'client'],
    combineActions({
        overrideFilters,
        sendNotification,
    }),
)(Insights);
